// Constantes y utilidades del Entorno Grupo

export const GROUP_ADMIN_ROLE = 'group_admin'

// Roles de usuario de dealer. En el formulario normal "Jefe de ventas/taller" es un solo rol (sales);
// garage se conserva solo para reconocer usuarios antiguos.
export const DEALER_ROLES = [
  { value: 'manager', text: 'Manager' },
  { value: 'sales', text: 'Jefe de ventas/taller' },
  { value: 'garage', text: 'Jefe de ventas/taller' },
  { value: 'logistics', text: 'Logística' },
  { value: 'commercial', text: 'Comercial' },
  { value: 'mechanic', text: 'Mecánico' },
  { value: 'cleaning', text: 'Limpieza' },
  { value: 'driver', text: 'Conductor' }
]

// Roles que se pueden elegir al crear o editar un usuario
export const DEALER_ROLE_OPTIONS = DEALER_ROLES.filter(r => r.value !== 'garage')

export const CONDITIONS = [
  { value: 'vn', text: 'VN' },
  { value: 'vo', text: 'VO' },
  { value: 'taller', text: 'Taller' }
]

export const COLABORADOR_TYPES = [
  { value: 'taller_reparacion', text: 'Taller de reparación' },
  { value: 'taller_pintura', text: 'Taller de pintura' },
  { value: 'lavadero', text: 'Lavadero' },
  { value: 'otro', text: 'Otro' }
]

// Nombres legibles de los permisos (el RBAC no guarda descripción)
export const PERMISSION_LABELS = {
  manage_dealer: 'Administrar concesionario',
  manage_users: 'Administrar usuarios',
  manage_notifications: 'Administrar notificaciones',
  manage_equipamiento_config: 'Configurar equipamiento',
  agregar_usuario_normal: 'Dar de alta usuarios',
  actualizar_usuario: 'Actualizar usuarios',
  importacion_masiva_excel: 'Importación masiva (Excel)',
  exportar_vehiculos: 'Exportar vehículos',
  descargar_comodato: 'Descargar comodatos',
  editar_comodato: 'Editar clausulado del comodato',
  view_chekbox_validacion: 'Ver validación de movimientos',
  usage_chekbox_validacion: 'Validar movimientos',
  create_movement_excepcional: 'Crear movimientos excepcionales',
  gestionar_vehiculo_todos: 'Gestionar tareas de vehículos',
  gestionar_vehiculo_location_estado_procesos: 'Gestionar estados de proceso de vehículos'
}

export function permissionLabel (name, description) {
  if (description && description !== name) return description
  if (PERMISSION_LABELS[name]) return PERMISSION_LABELS[name]
  const text = name.replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

// Roles que se configuran en Permisos: los mismos que un dealer puede asignar en su formulario de usuarios
export const PERMISSION_ROLES = [
  { value: 'manager', text: 'Manager' },
  { value: 'logistics', text: 'Logística' },
  { value: 'sales', text: 'Jefe de ventas/taller' },
  { value: 'commercial', text: 'Comercial' },
  { value: 'mechanic', text: 'Mecánico' },
  { value: 'cleaning', text: 'Limpieza' },
  { value: 'driver', text: 'Conductor' }
]

export const STATUS_ACTIVE = 10
export const STATUS_INACTIVE = 9

export function roleLabel (role) {
  const found = DEALER_ROLES.find(r => r.value === role)
  return found ? found.text : role
}

export function conditionLabel (condition) {
  const found = CONDITIONS.find(c => c.value === condition)
  return found ? found.text : condition
}

export function colaboradorTypeLabel (type) {
  const found = COLABORADOR_TYPES.find(t => t.value === type)
  return found ? found.text : (type || '—')
}

// Datos de la respuesta envuelta de la API ({ success, status, data })
export function apiData (response) {
  return response && response.data ? response.data.data : null
}

// Primer mensaje de error legible de una respuesta de la API
export function apiError (error, fallback = 'Se ha producido un error') {
  const data = error && error.response && error.response.data ? error.response.data.data : null
  if (!data) {
    return fallback
  }
  if (typeof data === 'string') {
    return data
  }
  if (data.message) {
    return data.message
  }
  if (data.errors) {
    const first = Object.values(data.errors)[0]
    return Array.isArray(first) ? first[0] : String(first)
  }
  return fallback
}

// Descarga un blob como fichero
export function downloadBlob (blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
